import React, { useState, useRef, useEffect } from "react";

import Sandwich from "./sandwich";
import useWindowDimensions from "../utils/resolution";
import SideDrawer from "./sideDrawer";
import NavLinks from "./navLinks";
import Backdrop from "./backdrop";

import "../assets/css/nav.css";
import "../assets/css/font.css";

function Nav() {
  const [showSideDrawer, setShowSideDrawer] = useState(false);
  const sandwichRef = useRef(null);
  const { width } = useWindowDimensions();

  const handleCloseSide = () => setShowSideDrawer(false);
  const handleOpenSide = () => setShowSideDrawer(true);
  const clickedLink = () => setShowSideDrawer(false);

  useEffect(() => {
    if (!showSideDrawer) return undefined;

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        setShowSideDrawer(false);
        sandwichRef.current?.focus();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showSideDrawer]);

  return (
    <React.Fragment>
      {showSideDrawer && <Backdrop onClick={handleCloseSide} />}
      <SideDrawer show={showSideDrawer} onClick={setShowSideDrawer}>
        <NavLinks onClick={clickedLink} />
      </SideDrawer>
      {width > 900 ? (
        <NavLinks />
      ) : (
        <Sandwich onClick={handleOpenSide} expanded={showSideDrawer} ref={sandwichRef} />
      )}
    </React.Fragment>
  );
}

export default Nav;
